/* eslint-disable vue/no-reserved-keys */
<template lang="html">
  <div class="content-item" @click="goDynamicTetail">
    <div class="content-item-left">
      <img class="avater" v-if="!isActual" v-lazy="`http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E7%A5%9E%E7%A7%98%E5%A4%B4%E5%83%8F.png?x-oss-process=image/resize,m_fill,w_72,h_72`" />
      <img class="avater" v-else-if="commenter.avatar" v-lazy="`${commenter.real_avatar !=='null' & commenter.real_avatar !=='' ?commenter.real_avatar:commenter.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`" />
      <img class="avater" v-else src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png?x-oss-process=image/resize,m_fill,w_72,h_72"/>
      <div class="content-item-body">
        <div class="content-item-body-header">
          <h2>{{(!isActual) ? '匿名' : commenter.fullname ? commenter.fullname:commenter.nickName}}</h2>
        </div>
        <img v-if="!content && isUp" class="isUp" src="../../../assets/images/dynamic/thumbs-up-black.svg"/>
        <img v-if="!content && !isUp" class="isUp" src="../../../assets/images/dynamic/thumbs-up-white.svg"/>
        <span v-else class="desc" v-html="content"></span>
        <div class="content-bottom">
          <div class="content-bottom-left">
            <h5>{{getShowTime(createTime)}}</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="content-item-imgs">
      <img v-if="circle && circle.images && circle.images.length > 0 && isvideo(circle.images[0].url)" class="maxImg"
        v-lazy="`${circle.images[0].url}?x-oss-process=image/resize,m_fill,w_96,h_96`" />
      <div v-else-if="circle && circle.images && circle.images.length > 0">
        <img v-lazy="`${circle.images[0].url}?x-oss-process=video/snapshot,t_1000,f_jpg,w_64,h_64`">
        <img src="../../../assets/images/dynamic/playBtn.png" class="play-img" />
      </div>
    </div>
  </div>
</template>
<script>
import { get, set } from '../../../utils/token'
import { getBeforeTimeStr } from '../../../utils/date'
export default {
  components: {
  },
  props: {
    id: {
      // type: Number,
      default: 0
    },
    isActual: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Object,
      default: () => {
        return {
          images: []
        }
      }
    },
    tale: {
      type: Number,
      default: 0
    },
    diss: {
      type: Number,
      default: 0
    },
    commenter: {
      type: Object,
      default: () => {
        return {
          avatar: '',
          nickName: '',
          id: ''
        }
      }
    },
    createTime: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isUp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modelSrc: [],
      initialIndex: 0,
      users: get('user')
    }
  },
  mounted () {
  },
  methods: {
    isvideo (url) {
      const flag = url.indexOf('/video_bbs/') === -1
      return flag
    },
    goDynamicTetail () {
      if (this.circle) {
        this.$router.push(`/exerland/dynamicTetail/${this.circle.id}`)
      }
      if (this.diss) {
        this.$router.push(`/exerland/makeComplaintsDetails/${this.diss}`)
      }
      if (this.tale) {
        this.$router.push(`/exerland/summoningOrderDetails/${this.tale}`)
      }
    },
    getShowTime (time) {
      return getBeforeTimeStr(time)
    },
    goCreate () {
      const dynamic = this.$parent.$refs.dynamic
      if (dynamic) {
        set('scrollDynamic', this.$parent.$refs.dynamic.scrollTop)
      }
      this.$router.push(`/exerland/create?circleId=${this.id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .customClass {
  width: 300px;
}
.content-item {
  padding: 23px 3.73vw 8px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  .content-item-left {
    display: flex;
    justify-content: space-between;
    .avater {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      margin-right: 16px;
    }
    .content-item-body {
      h2 {
        font-size: 16px;
        font-family: SFProText-Semibold, SFProText;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin-bottom: 1px;
      }
      h5 {
        font-size: 14px;
        font-family: SFProText-Regular, SFProText;
        font-weight: 400;
        color: rgba(60, 60, 67, 0.6);
        line-height: 13px;
      }
      .content-item-body-header {
        display: flex;
        justify-content: space-between;
      }
      .desc {
        width: 100%;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 24px;
        // width: 79.2vw;
        // text-overflow: ellipsis;
        // overflow: hidden;
        display: -webkit-box;
        // -webkit-line-clamp: 3;
        // -webkit-box-orient: vertical;
        word-wrap:break-word;
        word-break:break-all;
        overflow: hidden;
        margin: 4px 0;
      }
      .isUp {
        width: 15px;
        height: 15px;
        display: block;
        margin: 4px 0;
      }
      .content-bottom {
        font-size:11px;
        font-family:SFProText-Regular,SFProText;
        font-weight:400;
        color:rgba(60,60,67,0.6);
        line-height:13px;
      }
    }
  }
  .content-item-imgs {
    position: relative;
      img {
        width: 64px;
        // height: 64px;
      }
      .play-img {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -14px;
        margin-top: -14px;
        width: 28px;
        height: 28px;
      }
    }
}
</style>
